<div>
    <p>Available amount of EAN's for current retailer: {{availableEANs}}</p>
</div>
<div class="button-container">
    <app-button
                [buttonType]="'secondary'"
                [label]="'retailerData.uploadEAN' | translate"
                (click)="fileInputXLSX.click()">
        <input #fileInputXLSX type="file" class="file-upload" hidden
               (change)="uploadEANList($event)">
    </app-button>
</div>

